import { Button } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

interface DialogConfirmActionsProps {
  loading: boolean;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DialogConfirmActions: React.FC<DialogConfirmActionsProps> = ({
  loading,
  confirmLabel,
  onCancel,
  onConfirm,
}) => {
  const translate = useTranslate();

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
      <Button disabled={loading} onClick={onCancel} color="primary">
        {translate('ra.action.cancel')}
      </Button>
      <Button disabled={loading} onClick={onConfirm} color="primary">
        {confirmLabel}
      </Button>
    </div>
  );
};
